<template>
  <div>
    <Label v-bind="labelProps" :html-for="id" :bold="labelBold" v-if="label" :disabled="disabled">
      {{ label }}
    </Label>
    <money
      v-model="localValue"
      v-bind="formatOptions"
      :id="id"
      class="form-control input"
      :class="inputClass"
      :placeholder="placeholder"
      :disabled="disabled"
      :error="error"
      :maxlength="max"
      @keypress.enter.prevent="handleOnEnter"
      @keydown="$event.key === '-' && $event.preventDefault()"
    />
    <div class="input-description input-margin" v-if="description" :class="descriptionClass">
      {{ description }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Label from './Label';
import { numberBRToFloat } from '../../core/helpers/formater/number';

export default {
  name: 'InputQuantity',
  components: {
    Label,
  },
  props: {
    label: {
      type: String,
    },
    labelProps: {
      type: Object,
    },
    labelBold: {
      type: Boolean,
      default: () => false,
    },
    value: {
      required: false,
      type: [Number, String],
      default: 0,
    },
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    onEnter: {
      type: Function,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => ({
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      }),
    },
    prefix: {
      type: Boolean,
      default: () => true,
    },
    precision: {
      type: Number,
    },
    max: {
      type: Number,
      default: () => null,
    },
    suffix: {
      type: String,
      default: () => null,
    },
    description: {
      type: String,
    },
    success: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
    returnFormattedValue: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleOnEnter() {
      this.onEnter();
    },
    getPrecision() {
      if (this.precision === 0) return this.precision;

      const precision =
        this.precision || this.decimalConfiguration.quantity || this.options.precision;

      return precision;
    },
  },
  computed: {
    ...mapGetters('purchase', ['decimalConfiguration']),

    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        if (value !== this.value) {
          if (this.returnFormattedValue) {
            this.$emit('input', value, this.value);
          }

          if (!this.returnFormattedValue) {
            this.$emit('input', numberBRToFloat(value), this.value);
          }
        }
      },
    },
    inputClass() {
      return {
        success: this.success,
        error: this.error,
      };
    },

    formatOptions() {
      return {
        ...this.options,
        prefix: this.prefix ? this.options.prefix : '',
        suffix: this.suffix || '',
        precision: this.getPrecision(),
      };
    },
  },
};
</script>
